import { Title } from '#app/interface/cabinet/header/Dropdown/styles';
import Dropdown from '#app/interface/cabinet/header/Dropdown/Dropdown';
import React from 'react';
import { routes } from '#app/constants/routes';

const InvestingDropdown = ({ i18n, data, handleMenu, url }) => {
  const condition4 =
    routes.investingValidPaths.includes(url) ||
    url.includes(routes.investing.diagrams) ||
    url.includes(routes.roboadvisor.index);

  const menuLinks = [
    { id: 'investing-menu-0', link: routes.investing.case, text: i18n.menu.dashboard },
    { id: 'investing-menu-5', link: routes.investing.chart(), text: i18n.menu.charts },
    { id: 'investing-menu-2', link: routes.investing.invest, text: i18n.menu.investList },
    { id: 'investing-menu-repos', link: routes.investing.repos, text: i18n.menu.repos },
    {
      id: 'investing-menu-4',
      link: routes.investing.paymentsCalendar,
      text: i18n.menu.paymentsСalendar,
    },
    { id: 'investing-menu-6', link: routes.investing.diagrams, text: i18n.menu.diagrams },
    { id: 'investing-menu-7', link: routes.roboadvisor.index, text: i18n.menu.robo },
  ];

  return (
    <Dropdown
      id="dropdown-investing"
      width="auto"
      containerId="dropdown-investing-container"
      links={menuLinks}
    >
      <Title
        id="accounting-tab-4"
        className={condition4 ? 'active' : ''}
        onClick={(e) => handleMenu(e, routes.investing.case)}
      >
        {i18n.menu.invest}
      </Title>
    </Dropdown>
  );
};

export default InvestingDropdown;
